<template>
  <SelectComponent
    v-model="model"
    :item-list="itemList"
    :item-value="itemValue"
    :tool-tip-text="toolTipText"
    @input="selectedValue"
  />
</template>

<script>
import SelectComponent from "../UtilComponents/SelectComponent.vue";

export default {
  name: "SharingResearchSoftware",
  components: { SelectComponent },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["input"],
  data: () => {
    return {
      itemList: ["required", "suggested", "not covered", "other"],
      itemSelected: [],
      itemValue: [],
      toolTipText:
        "Policy clearly states that sharing research software is required and provides clarity on any legitimate exceptions. Multiple selections will be joined with OR.",
    };
  },
  computed: {
    model: {
      get() {
        return this.itemSelected;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    itemSelected(newValue) {
      this.itemValue = newValue;
    },
  },
  mounted() {
    //Pre-fill selected values on edit advanced search fields
    this.itemValue = this.value;
  },

  methods: {
    selectedValue(item) {
      let itemValue = item.map(({ value }) => value);
      this.itemSelected = itemValue;
    },
  },
};
</script>
